import type { ChangeLogHistory } from 'scenes/Producer/Product/MyProducts/components/QuickView/components/ProductChangeHistory/ChangeHistoryContent/ChangeHistoryDetails/constants';
import type {
  ChangeHistoryFilter,
  ProductChangeHistoryResponse,
  UserModifiedProductFilter
} from 'v2/interfaces/productChangeHistory';

import { apiServiceProxy } from '../api-proxy';
import type { ApiServiceProxy } from '../api-proxy';

class ProductChangeHistory {
  constructor(private readonly apiServices: ApiServiceProxy) {}

  public getChangeHistory = (productId: number, filter: ChangeHistoryFilter): Promise<ProductChangeHistoryResponse> => {
    return this.apiServices.get(`/products/${productId}/history`, filter).then(response => response);
  };

  public getUsersChangeHistory = (productId: number, filter: UserModifiedProductFilter) => {
    const { edited_at, edited_at_final } = filter;
    return this.apiServices
      .get(`/products/${productId}/history/users`, { edited_at, edited_at_final })
      .then(response => response.data);
  };

  public getChangeHistoryDetails = (productId: number, historyId: number): Promise<ChangeLogHistory[]> => {
    return this.apiServices.get(`/products/${productId}/history/${historyId}/details`).then(response => response.data);
  };
}

const productChangeHistoryService = new ProductChangeHistory(apiServiceProxy);
export default productChangeHistoryService;
